import { combineReducers } from "redux";

// Redux src
import reduxAuth from "@core/redux/reducers/auth/index";
import reduxAppSnackbar from "@core/redux/reducers/app/snackbar";
import reduxAppDataSetting from "@core/redux/reducers/app/dataSetting";
import reduxCamp from "@core/redux/reducers/camp/index";
import reduxAppSpinner from "@core/redux/reducers/app/spinner";
// import reduxAppDropdown from "../@core/redux/reducers/app/dropdrown";
import reduxGame from "@core/redux/reducers/game/index";
import reduxHome from "@core/redux/reducers/home/index";
// import reduxBank from "./../@core/redux/reducers/bank/index";
// import reduxAppDialog from "./../@core/redux/reducers/app/dialog";
import reduxDeposit from "@core/redux/reducers/deposit/index";
import reduxWithdraw from "@core/redux/reducers/withdraw/index";
import reduxAffiliate from "@core/redux/reducers/affiliate/index";
import reduxCashback from "@core/redux/reducers/cashback/index";
// import reduxAppCondition from "./../@core/redux/reducers/app/conditions";
// import reduxAppContact from "./../@core/redux/reducers/app/contact";
import reduxAppPopup from "@core/redux/reducers/app/popup";
import reduxAppPassword from "@core/redux/reducers/app/password";
// import reduxProfile from "../@core/redux/reducers/profile";
// import reduxActivity from "../@core/redux/reducers/activity";
// import reduxAppConfirm from "../@core/redux/reducers/app/confirm";
import reduxAppAlert from "@core/redux/reducers/app/alert";
// import reduxShop from "../@core/redux/reducers/shop/index";
import reduxPromotion from "@core/redux/reducers/promotion/index";
// import reduxCheckPromotion from "../@core/redux/reducers/promotion/checkPromotion";
import reduxAppScrollPosition from "@core/redux/reducers/app/scrollPosition";
// import reduxAppProcessing from "../@core/redux/reducers/app/processing";
import reduxAppCMS from "@core/redux/reducers/app/cms";
// import reduxRank from "../@core/redux/reducers/rank";
import reduxAppDemo from "@core/redux/reducers/app/demo";
import reduxChangePass from "@core/redux/reducers/profile/changepass";
import reduxHistory from "@core/redux/reducers/history/index";
import reduxAppSearchGame from "@core/redux/reducers/app/searchGame";
import reduxAppWheel from "@core/redux/reducers/app/wheel";
import reduxLotteryHome from "@core/redux/reducers/lottery/home";
import reduxAppMenuFooter from "@core/redux/reducers/app/menuFooter";
import reduxLotteryBasket from "@core/redux/reducers/lottery/basket";
import reduxLotteryInfo from "@core/redux/reducers/lottery/info";
import reduxTimecheck from "@core/redux/reducers/lottery/timeCheck";
import reduxLotteryOrderList from "@core/redux/reducers/lottery/orderList";
import reduxLotteryYiki from "@core/redux/reducers/lottery/yiki";
import reduxLotteryReward from "@core/redux/reducers/lottery/reward";
import reduxReview from "@core/redux/reducers/review";
import reduxLuckyWinner from "@core/redux/reducers/luckyWinner/index";
import reduxCampaign from "@core/redux/reducers/campaign";

export default combineReducers({
    reduxAuth,
    reduxAppDataSetting,
    reduxCamp,
    reduxGame,
    reduxHome,
    reduxDeposit,
    reduxAppSpinner,
    reduxWithdraw,
    reduxAffiliate,
    reduxCashback,
    reduxAppAlert,
    reduxAppSnackbar,
    reduxPromotion,
    reduxAppScrollPosition,
    reduxAppCMS,
    reduxChangePass,
    reduxHistory,
    reduxAppDemo,
    reduxAppSearchGame,
    reduxAppWheel,
    reduxLotteryHome,
    reduxAppPopup,
    reduxAppMenuFooter,
    reduxLotteryBasket,
    reduxLotteryInfo,
    reduxTimecheck,
    reduxLotteryOrderList,
    reduxLotteryYiki,
    reduxLotteryReward,
    reduxReview,
    reduxAppPassword,
    reduxLuckyWinner,
    reduxCampaign
});